import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Theme/Common'
import { gapY } from '@mobi/component-library/Utils/gap'

export const BlockDebitCardFormStyled = styled.div(
  {
    display: 'grid',
  },
  gapY(spacing.sm)
)

export const ParagraphStyled = styled('p')({
  textAlign: 'left',
  color: colors.neutral[900],
  margin: '0',
  ...font.size.lg,
})

export const ModalContentStyled = styled('div')({
  color: colors.neutral[800],
  margin: spacing.smx1,
  ...font.size.lg,
})
